
import { useEffect, useState } from 'react';

export default function Hero() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden">
      {/* Full‑bleed cinematic background */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/0058eca2585c86415d1219d7dd04e9dd.jpg"
          alt="Deluxe AI Systems Command Center"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0B0D10]/70 via-[#0B0D10]/50 to-[#0B0D10]" />
      </div>

      {/* Floating nav bar */}
      <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-500" id="main-nav">
        <div className="max-w-7xl mx-auto px-8 py-5 flex items-center justify-between">
          <img
            src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/ccf689b9a030d4a511e23c69d6ff7870.png"
            alt="Deluxe AI Systems"
            className="h-8 w-auto"
          />
          <div className="hidden md:flex items-center gap-10">
            <a href="#solutions" className="text-[#C5C9CF] hover:text-white text-sm font-medium transition-colors duration-300 cursor-pointer">
              Solutions
            </a>
            <a href="#industries" className="text-[#C5C9CF] hover:text-white text-sm font-medium transition-colors duration-300 cursor-pointer">
              Industries
            </a>
            <a href="#process" className="text-[#C5C9CF] hover:text-white text-sm font-medium transition-colors duration-300 cursor-pointer">
              Process
            </a>
            <a href="#results" className="text-[#C5C9CF] hover:text-white text-sm font-medium transition-colors duration-300 cursor-pointer">
              Results
            </a>
          </div>
          <a
            href="#contact"
            className="px-6 py-2.5 bg-white/10 backdrop-blur-md border border-white/20 text-white text-sm font-medium rounded-full hover:bg-white/20 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Get Started
          </a>
        </div>
      </nav>

      {/* Hero content — Apple‑style centered large type */}
      <div
        className={`relative z-10 max-w-5xl mx-auto px-6 text-center w-full transition-all duration-1000 ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <p className="text-sm md:text-base font-medium tracking-[0.3em] text-[#8C9198] mb-6 uppercase">
          Deluxe AI Systems
        </p>

        <h1
          className="text-5xl md:text-7xl lg:text-[5.5rem] font-bold mb-8 tracking-tight text-white leading-[1.05]"
          style={{ fontFamily: "'SF Pro Display', 'Inter', system-ui, sans-serif" }}
        >
          AI Systems Built for<br />
          Premium Service Brands
        </h1>

        <p className="text-lg md:text-xl text-[#8C9198] mb-14 max-w-2xl mx-auto font-light leading-relaxed">
          Automation engineered for Medspas, Law Firms, and Real Estate teams that demand precision
          performance and elevated client experiences.
        </p>

        <div className="flex flex-col sm:flex-row gap-5 justify-center items-center">
          <a
            href="#contact"
            className="group px-8 py-4 bg-white text-[#0B0D10] font-semibold text-base rounded-full transition-all duration-300 hover:scale-105 hover:shadow-[0_0_50px_rgba(255,255,255,0.2)] cursor-pointer whitespace-nowrap"
          >
            Request a Strategy Call
          </a>

          <a
            href="#solutions"
            className="px-8 py-4 text-[#C5C9CF] font-semibold text-base rounded-full transition-all duration-300 hover:text-white cursor-pointer whitespace-nowrap flex items-center gap-2"
          >
            Explore Our Systems
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line text-lg" />
            </span>
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <div
        className={`absolute bottom-10 left-1/2 -translate-x-1/2 z-10 transition-all duration-1000 delay-700 ${
          visible ? 'opacity-100' : 'opacity-0'
        }`}
      >
        <div className="w-6 h-10 border-2 border-[#8C9198]/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2.5 bg-white/70 rounded-full animate-bounce" />
        </div>
      </div>
    </section>
  );
}
